import React, { useState } from 'react'
import MessageHeading from '../../components/CommonComponents/MessageHeading'
import MessageBox from '../../components/CommonComponents/MessageBox'
import { useMyContext } from '../../components/Provider/CommonProvider'
import MessageSubHeading from '../../components/CommonComponents/MessageSubHeading'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import S3SyncModal from '../../components/CommonComponents/S3SyncModal.jsx'
import { FaCloudDownloadAlt } from 'react-icons/fa';
import FileUploader from '../FileUploader';

const SiteStorage = ({ storageSetting, adminSetting }) => {
    const { handleFileChangeProvider, fetchRequest } = useMyContext()
    const baseURL = process.env.REACT_APP_Baseurl

    const videoApi = `${baseURL}/admin/library/upload`

    const [state, setState] = useState({
        upload_type: adminSetting?.productType === "playout" ? "substitute" : "video"
    })
    const [showS3Modal, setShowS3Modal] = useState(false);
    const handleTypeChange = (val) => {
        setState((prev) => ({
            ...prev,
            upload_type: val
        }))
    }
    const handleLibraryChange = async (e) => {
        const files = e.target.files;
        const isVideoUpload = state?.upload_type === 'video' || state?.upload_type === 'trailer' || state?.upload_type === 'substitute';
        const isAudioUpload = state?.upload_type === 'audio';
        // Allow video and audio MIME types
        const allowedTypes = isVideoUpload ? /video\/(mp4|x-matroska|webm|quicktime|avi)/ : isAudioUpload ? /audio\/(mpeg|mp3|wav|ogg|aac|flac)/ : null;

        if (!allowedTypes) {
            toast.error(`Unsupported upload type: ${state?.upload_type}`);
            e.target.value = '';
            return;
        }
        for (let file of files) {
            if (!allowedTypes.test(file.type)) {
                toast.error(`Unsupported file format: ${file.name}`);
                e.target.value = '';
                return;
            }
        }

        if (!files?.length) return;

        const { site_storage_limit, site_storage_memory } = storageSetting;

        // Convert storage limit to bytes — decimal units (1 TB = 1000 GB = 1e12 bytes)
        // Matches Bunny CDN API, AdminDashboardController and all CDN storage checks.
        const memoryUnits = {
            MB: 1e6,    // 1,000,000 bytes
            GB: 1e9,    // 1,000,000,000 bytes
            TB: 1e12,   // 1,000,000,000,000 bytes
        };

        const unitMultiplier = memoryUnits[site_storage_memory];
        if (!unitMultiplier) {
            alert(`Invalid storage unit: ${site_storage_memory}`);
            return;
        }

        const byteLimit = site_storage_limit * unitMultiplier;

        // Calculate total file size
        const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);

        if (totalSize > byteLimit) {
            alert(`Upload exceeds limit: ${site_storage_limit} ${site_storage_memory}`);
            e.target.value = null; // Reset file input
            return;
        }

        // Proceed with upload
        handleFileChangeProvider(e, `${videoApi}?upload_type=${state?.upload_type}`, "library", {})
        e.target.value = null; // Reset file input again
    };

    return (
        <div className='theme-bg-color p-5 rounded-5 mb-3 '>
            <MessageHeading text={`Upload to Site Library`} padding border />
            <div className='d-flex flex-wrap mb-3 align-items-center justify-content-start gap-3'>
                {adminSetting?.productType !== "playout" && adminSetting?.productType !== "video_library" ? (
                    <>
                        <button
                            id="videoButton"
                            className={` ${state?.upload_type === 'video' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('video')}
                        > Video</button>
                        <button
                            id="audioButton"
                            className={` ${state?.upload_type === 'audio' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('audio')}
                        > Audio</button>
                        <button
                            id="trailerButton"
                            className={` ${state?.upload_type === "trailer" ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('trailer')}
                        > Trailer</button>
                        <button
                            id="substituteButton"
                            className={` ${state?.upload_type === "substitute" ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('substitute')}
                        > Substitute</button>
                    </>
                ) : adminSetting?.productType == "playout" ? (
                    <>
                        <button
                            id="videoButton"
                            className={` ${state?.upload_type === 'video' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('video')}
                        > Video</button>
                        <button
                            id="substituteButton"
                            className={` ${state?.upload_type === "substitute" ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('substitute')}
                        > Substitute</button>
                    </>
                ) : (
                    <>
                        <button
                            id="videoButton"
                            className={` ${state?.upload_type === 'video' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                            onClick={() => handleTypeChange('video')}
                        > Video</button>
                        {adminSetting?.enable_library_audio === 1 && (
                            <button
                                id="audioButton"
                                className={` ${state?.upload_type === 'audio' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                                onClick={() => handleTypeChange('audio')}
                            > Audio</button>
                        )}
                        {adminSetting?.enable_library_trailer === 1 && (
                            <button
                                id="trailerButton"
                                className={` ${state?.upload_type === "trailer" ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-4 py-3 px-5`}
                                onClick={() => handleTypeChange('trailer')}
                            > Trailer</button>
                        )}
                    </>

                )}

            </div>
         
            <div className="d-flex justify-content-center mb-4">
                {storageSetting?.aws_storage === 1 && ['video', 'audio', 'trailer', 'substitute'].includes(state?.upload_type) && (
                    <button
                        type="button"
                        className="d-flex align-items-center gap-2 theme-border-color-primary border-1 border-solid theme-button-text-color rounded-4 py-2 px-4 shadow-sm"
                        onClick={() => setShowS3Modal(true)}
                        style={{ fontSize: '0.85rem' }}
                    >
                        <FaCloudDownloadAlt size={20} color={storageSetting?.aws_storage === 1 ? "#ffff" : "#ccc"} />
                        AWS Sync File ({state.upload_type?.charAt(0).toUpperCase() + state.upload_type?.slice(1)})
                    </button>
                )}
            </div>

            {state?.upload_type === 'video' && storageSetting?.bunnyCdnStorage == 1 && storageSetting?.transcoding_access == 1 ? (
                <FileUploader nextHref={(vid) => `/library-preview/${vid}`} />
            ) : (
                <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                    <div className="dropZoneText d-flex align-items-center justify-content-center">
                        <MessageBox text={`Drag and drop ${state?.upload_type === 'video' ? "video" : "audio"} files here, or click to select files`} classname="theme-text-color" />
                    </div>
                    <input
                        type="file"
                        id="fileInput"
                        accept={state?.upload_type === 'video' ? "video/*" : "audio/mp3"}
                        className="w-100 h-100"
                        multiple
                        onChange={(e) => handleLibraryChange(e)}
                    />
                </div>
            )}


            <S3SyncModal
                open={showS3Modal}
                onClose={() => setShowS3Modal(false)}
                upload_type={state?.upload_type}
                onSuccess={() => {
                    window.location.href = '/library';
                }}
            />

            <MessageSubHeading className={"text-center mt-4"} text={`Max Upload Limit (${storageSetting?.site_storage_limit} ${storageSetting?.site_storage_memory})`} />
        </div>
    )
}
const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
});

export default connect(mapStateToProps)(SiteStorage)